"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eqFilterParams = void 0;
const common_types_1 = require("../common/common-types");
function eqFilterParams({ field, value, }) {
    if (value === undefined) {
        return undefined;
    }
    else {
        return {
            filters: [
                {
                    operation: common_types_1.ApiFilterOperation.EQ,
                    field,
                    value,
                },
            ],
        };
    }
}
exports.eqFilterParams = eqFilterParams;
//# sourceMappingURL=common-params.js.map